<template>
    <img
        :src="$page.props.setting.baseUrl + '/img/logo-sipandu-300-300.png'"
        alt="logo aplikasi "
    />
</template>